import React, { Component } from 'react';
import { VideoPlayer } from './';
import find from 'lodash/find';

const supportedUrlFormats = [
  {
    type: 'youtube',
    regex: /(youtu(.?)be)/
  },
  {
    type: 'vimeo',
    regex: /(vimeo)/
  },
];

const idParsers = {
  'youtube': [
    /(?:v=)([a-zA-Z0-9-]+(?=&*))/,
    /(?:youtu.be\/)([a-zA-Z0-9-]+)/,
    /(?:embed\/)([a-zA-Z0-9-]+)/,
  ],
  'vimeo': [
      /(?:vimeo.com\/(?:video\/)*)([0-9-]+)/,
    ]
};

const detectUrlFormat = (videoUrl) => {
  const detectedFormat = find(supportedUrlFormats, (format) => {
    return videoUrl.match(format.regex);
  });
  return detectedFormat ? detectedFormat.type : null;
};

const detectVideoId = (type, videoUrl) => {
  const parser = find(idParsers[type], (regex) => {
    return videoUrl.match(regex);
  });

  if(!parser) return null;
  const matches = videoUrl.match(parser);
  if(matches && matches.length > 1) {
    return matches[1];
  }
  return null;
};

class VideoPlayerContainer extends Component {
  constructor(props) {
    super(props);

    const { videoUrl } = props;
    const type = detectUrlFormat(videoUrl);
    const id = type ? detectVideoId(type, videoUrl) : null;
    
    this.state = {
      videoUrl: props.videoUrl,
      type,
      id
    };
  }

  render() {
    const { type, id } = this.state;
    return (
      <VideoPlayer type={type} id={id} />
    );
  }
};

export default VideoPlayerContainer;


// WEBPACK FOOTER //
// ./src/modules/content/components/VideoPlayerContainer.js